import { FAQItem } from './types';

export const GB_FAQS: FAQItem[] = [
  {
    id: 'works-in-uk',
    titleKey: 'does_fi_work_in_the_uk',
    answerKey:
      'yes_fi_works_across_all_major_uk_mobile_networks_including_ee_vodafone_three_and_o2_your_dogs_collar_connects_automatically_to_the_strongest_available_signal_no_matter_where_you_are_in_the_uk',
  },
  {
    id: 'phone-carrier-requirement',
    titleKey: 'do_i_need_a_specific_phone_carrier_to_use_fi',
    answerKey:
      'fi_works_with_any_smartphone_regardless_of_your_phone_carrier_the_fi_collar_has_its_own_built_in_sim_and_connects_to_mobile_networks_independently_just_download_the_fi_app_to_start_tracking',
  },
  {
    id: 'stolen-dog-recovery',
    titleKey: 'how_does_fi_help_if_my_dog_is_stolen',
    answerKey:
      'fi_has_helped_many_owners_recover_stolen_dogs_using_real_time_gps_tracking_and_instant_alerts_the_moment_a_fi_dog_leaves_a_safe_zone_the_collar_is_discreet_secure_and_cant_be_removed_without_you_knowing',
  },
  {
    id: 'why-membership-uk',
    titleKey: 'why_do_i_need_a_membership_what_does_it_include',
    answerKey:
      'fi_memberships_include_unlimited_cellular_data_for_real_time_tracking_cloud_stored_health_history_and_24_7_gps_coverage_across_the_uk_the_collar_is_yours_to_keep_youre_paying_for_the_service_not_renting_the_device',
  },
  {
    id: 'multi-dog-discounts',
    titleKey: 'do_you_offer_discounts_for_multiple_dogs',
    answerKey:
      'we_offer_multi_collar_bundles_at_a_reduced_rate_each_dog_needs_their_own_collar_and_membership_but_when_you_add_multiple_collars_to_your_order_bundle_pricing_is_applied_contact_us_if_you_have_3_plus_dogs_for_custom_pricing_options',
  },
  {
    id: 'uk-delivery-time',
    titleKey: 'how_long_does_uk_delivery_take',
    answerKey:
      'standard_uk_delivery_takes_9_12_business_days_youll_receive_tracking_information_via_email_once_your_order_ships_we_offer_free_delivery_on_all_uk_orders',
  },
  {
    id: 'british-weather',
    titleKey: 'is_fi_built_for_british_weather',
    answerKey:
      'absolutely_the_collar_is_rated_ip68_and_ip66k_for_water_resistance_and_designed_to_handle_whatever_british_weather_throws_rain_puddles_muddy_walks_and_swimming_are_all_no_problem',
  },
  {
    id: 'collar-fit-returns',
    titleKey: 'what_if_the_collar_doesnt_fit',
    answerKey: 'we_offer_free_returns_within_30_days_if_the_size_isnt_right_well_exchange_it_at_no_extra_cost',
  },
  {
    id: 'data-protection-gdpr',
    titleKey: 'how_is_my_data_protected',
    answerKey:
      'fi_takes_data_privacy_seriously_we_comply_with_gdpr_and_uk_data_protection_regulations_and_we_encrypt_and_securely_store_your_dogs_location_and_health_data_you_can_request_data_deletion_at_any_time_through_the_app_settings',
  },
];
